import {merge} from './utils';
import {INTERNAL_OPTIONS, DEFAULT_OPTIONS} from './options';
import {getDefaultTheme, THEME_DARK, THEME_LIGHT} from './themes';

// API methods allowed to be invoked externally
const EXTERNALS = [
    'configure'
]

class AgeGO {
    /**
     * @param scope
     * @param {OverlayRenderer} overlayRenderer
     * @param {ContentBlurRenderer} contentBlurRenderer
     * @param {AccessManager} accessManager
     */
    constructor(
        scope,
        overlayRenderer,
        contentBlurRenderer,
        accessManager
    ) {
        this.scope = scope;
        this.overlayRenderer = overlayRenderer;
        this.contentBlurRenderer = contentBlurRenderer;
        this.accessManager = accessManager;
    }

    // On API message
    onMessage() {
        if (1 > arguments.length) {
            throw '[AgeGO] Illegal method call - invalid method';
        }

        const method = arguments[0];

        if (-1 === EXTERNALS.indexOf(method)) {
            throw '[AgeGO] Illegal method call - ' + method;
        }

        const args = (1 === arguments.length ? [arguments[0]] : Array.apply(null, arguments)).splice(1);
        this[method].apply(this, args);

        if ('configure' === method) {
            this.start();
        }
    }

    // Configure script
    configure(options) {
        if (options && options.overlay && options.overlay.theme) {
            if ('light' === options.overlay.theme) {
                DEFAULT_OPTIONS.overlay.style = THEME_LIGHT;
            } else if ('dark' === options.overlay.theme) {
                DEFAULT_OPTIONS.overlay.style = THEME_DARK;
            } else if ('auto' === options.overlay.theme) {
                DEFAULT_OPTIONS.overlay.style = getDefaultTheme(this.scope);
            } else {
                throw '[AGEGO] Unknown base theme, expected "dark", "light" or "auto"';
            }
        } else {
            DEFAULT_OPTIONS.overlay.style = getDefaultTheme(this.scope);
        }

        this.options = merge(DEFAULT_OPTIONS, options);
        this.accessManager.configure(this.options);
        this.contentBlurRenderer.configure(this.options);
        this.overlayRenderer.configure(this.options);

        if (!this.options.siteId) {
            throw '[AGEGO] Failed to initialize, "siteId" is not configured';
        }
    }

    // Before page unload or script destroy
    flush() {
    }

    // Entry point for the main logic
    start() {
        const redirectReturnResult = this.accessManager.checkRedirectReturn(this.scope);
        let redirectError = undefined;

        if (false !== redirectReturnResult) {
            if (true === redirectReturnResult) {
                this.accessManager.onAgeVerified();

                try {
                    this.options.events.onVerifiedBefore();
                } catch (e) {
                    console.error('[AGEGO] error in event listener', e)
                }
                return;
            }
            redirectError = redirectReturnResult;
        }


        if (this.accessManager.isAccessGranted()) {
            try {
                this.options.events.onVerifiedBefore();
            } catch (e) {
                console.error('[AGEGO] error in event listener', e)
            }
            return;
        }

        if ('auto-redirect' === this.options.verifyMode) {
            this.scope.location.href = this.accessManager.createRedirectURL(
                INTERNAL_OPTIONS.endpoint,
                this.accessManager.getCreateSessionNonce()
            );
            return;
        }

        this.contentBlurRenderer.render();
        this.overlayRenderer.render(redirectError);
    }
}

export {AgeGO};
